angular.module('TetherApp').factory('subscriptionService', [
    '$http',
    function($http) {

        let randomString = function randomString(length, chars) {
            let result = '';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let deleteSubscription = function (subscriptionId) {
            let uri = '/subscription/' + subscriptionId;
            return $http.delete(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        return {
            deleteSubscription: deleteSubscription
        }
    }
]);
